import { routerRedux } from 'dva/router';
import { findUserAbnormalDetail } from '../services/report';
import { PATH_HOME } from '../utils/constants';

export default {
  namespace: 'userAbnormallyDetails',
  state: {
    userSummary: {},
    cancelUserAbnormal: [],
    earlyEndUserAbnormal: [],
    extendUserAbnormal: [],
    normalUserAbnormal: [],
    selectedTabKey: '1',
    startTime: '',
    endTime: '',
    pageTotals: 0,
    pageSize: 5,
    pageCurrent: 1
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *clickToDetail({ userSummary, startTime, endTime }, { call, select, put }) {
      let userId = userSummary.creatorId;
      let { pageSize } = yield select(state => state.userAbnormallyDetails);
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);

      let { status, data } = yield call(findUserAbnormalDetail, {
        token: token,
        userId,
        startDate: startTime,
        endDate: endTime,
        abnormalType: 1,
        lang: locale,
        pageNo: 1,
        pageSize
      });
      if (0 == status) {
        let { list: cancelUserAbnormal, total } = data;
        yield put({
          type: 'setState',
          payload: {
            selectedTabKey: '1',
            userSummary: userSummary,
            cancelUserAbnormal: cancelUserAbnormal,
            earlyEndUserAbnormal: [],
            extendUserAbnormal: [],
            normalUserAbnormal: [],
            startTime: startTime,
            endTime: endTime,
            pageTotals: total,
            pageCurrent: 1
          }
        });
        yield put(routerRedux.push(`${PATH_HOME}userAbnormalDetail`));
      }
    },
    *changeSelectTab({ selectedKey }, { call, select, put }) {
      let { userSummary, startTime, endTime, pageSize } = yield select(
        state => state.userAbnormallyDetails
      );
      let userId = userSummary.creatorId;
      if (userId) {
        const { token } = yield select(state => state.login);
        const { locale } = yield select(state => state.i18n);
        let { status, data } = yield call(findUserAbnormalDetail, {
          token: token,
          userId,
          startDate: startTime,
          endDate: endTime,
          abnormalType: selectedKey,
          lang: locale,
          pageNo: 1,
          pageSize
        });
        if (0 == status) {
          let { list, total } = data;
          let newPayload = {
            selectedTabKey: selectedKey,
            pageTotals: total,
            pageCurrent: 1
          };
          if (1 == selectedKey) {
            newPayload['cancelUserAbnormal'] = list;
          } else if (2 == selectedKey) {
            newPayload['earlyEndUserAbnormal'] = list;
          } else if (3 == selectedKey) {
            newPayload['extendUserAbnormal'] = list;
          } else if (4 == selectedKey) {
            newPayload['normalUserAbnormal'] = list;
          }
          yield put({ type: 'setState', payload: newPayload });
        }
      }
    },
    *changePage({ pageNo }, { call, select, put }) {
      let {
        userSummary,
        startTime,
        endTime,
        pageSize,
        selectedTabKey
      } = yield select(state => state.userAbnormallyDetails);
      let userId = userSummary.creatorId;
      if (userId) {
        const { token } = yield select(state => state.login);
        const { locale } = yield select(state => state.i18n);
        let { status, data } = yield call(findUserAbnormalDetail, {
          token: token,
          userId,
          startDate: startTime,
          endDate: endTime,
          abnormalType: selectedTabKey,
          lang: locale,
          pageNo,
          pageSize
        });
        if (0 == status) {
          let { list, total } = data;
          let newPayload = { pageTotals: total, pageCurrent: pageNo };
          if (1 == selectedTabKey) {
            newPayload['cancelUserAbnormal'] = list;
          } else if (2 == selectedTabKey) {
            newPayload['earlyEndUserAbnormal'] = list;
          } else if (3 == selectedTabKey) {
            newPayload['extendUserAbnormal'] = list;
          } else if (4 == selectedTabKey) {
            newPayload['normalUserAbnormal'] = list;
          }
          yield put({ type: 'setState', payload: newPayload });
        }
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {});
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/userAbnormallyDetail.js